import React, { useContext } from 'react';
import S from "./QuarterlyReturns";
import CardHeader from "../CardHeader";
import FundContext from '@/components/FundSingle/FundProvider';
import Table from "../../../Table/index";
import moment from 'moment';

export interface returnType {
    Date: string;
    TimePeriod: string;
    Value: number;
}

const QuarterlyReturns: React.FC<FundSingle> = () => {
    const { fundCompareBenchmarkData, fundRiskDetails } = useContext(FundContext);
    
    if (!fundCompareBenchmarkData) return null;

    var fondReturns = fundRiskDetails.HistoricalPerformanceSeries.find((item: any) => item.ReturnType === 'Nav' && item.Frequency === 'Q' && item.TimePeriod == 'M3').Return;

    var tableRows = {};

    fondReturns.forEach((returns: returnType) => {
        var year = new Date(returns.Date).getFullYear();
        
        if (!tableRows[year]) {
            tableRows[year] = [];
        }

        tableRows[year].push(returns.Value != undefined && returns.Value.toFixed(2));
    });

    // Loop through each year and reverse the order of the quarters
    Object.keys(tableRows).forEach((year) => {
        tableRows[year].reverse();
    });

    // Check if the final year is not complete (4 quarters). If not, add - as placeholder values
    const currentYear = new Date().getFullYear();
    const currentYearData = tableRows[currentYear];
    if (currentYearData && currentYearData.length < 4) {
        const missingQuarters = 4 - currentYearData.length;
        for (let i = 0; i < missingQuarters; i++) {
            currentYearData.push('-');
        }
    }

    // Only get last 5 years of data
    tableRows = Object.keys(tableRows)
        .sort((a, b) => b.localeCompare(a))
        .slice(0, 5)
        .reduce((obj, key) => {
            obj[key] = tableRows[key];
            return obj;
        }
        , {});

    // fondReturns is an array of objects with Date, TimePeriod and Value.
    // We want to group them by year (using the Date property) and then by quarter (using the TimePeriod property).

    var tableData = {
        headings: ['', 'Q1', 'Q2', 'Q3', 'Q4'],
        rows: tableRows
    }

    return (
        <S.AllocationWrapper>
            <CardHeader title="Kvartalsavkastningar % (SEK)" subTitle={moment(new Date()).format('YYYY-MM-DD')} />
            <Table tableData={tableData} reverse={true} />
        </S.AllocationWrapper>
    );
};

export default QuarterlyReturns;
